import React from 'react';
import headerLogo from '../assets/libby-header-logo.png';
import { SHOW_GAMES, SHOW_MUSIC, SHOW_NEWSLETTER, SHOW_SHOP } from '../config';

const ALL_LINKS = [
  { href: '#foundation', label: 'About' },
  { href: '#explore', label: 'Explore' },
  { href: '/games', label: 'Games' },
  { href: '/music', label: 'Tunes' },
  { href: '/shop', label: 'Shop' },
  { href: '#newsletter', label: 'Join the list' },
  { href: '#amazon', label: 'Buy now' },
];

const LINKS = ALL_LINKS.filter(link => {
  if (!SHOW_GAMES && link.href === '/games') return false;
  if (!SHOW_MUSIC && link.href === '/music') return false;
  if (!SHOW_SHOP && link.href === '/shop') return false;
  if (!SHOW_NEWSLETTER && link.href === '#newsletter') return false;
  return true;
});

export const SHOP_NAV_LINKS = [
  { href: '/', label: 'Home' },
  ...(SHOW_SHOP ? [{ href: '/shop', label: 'Shop' }] : []),
];

export const GAMES_NAV_LINKS = [
  { href: '/', label: 'Home' },
  ...(SHOW_GAMES
    ? [
        { href: '/games', label: 'Games' },
        { href: '/play/color-with-me', label: 'Color With Me' },
        { href: '/play/detective-tully', label: 'Detective Tully' },
      ]
    : []),
  ...(SHOW_MUSIC ? [{ href: '/music', label: 'Tunes' }] : []),
  ...(SHOW_SHOP ? [{ href: '/shop', label: 'Shop' }] : []),
];

export const MUSIC_NAV_LINKS = [
  { href: '/', label: 'Home' },
  { href: '/music', label: 'Tunes' },
  ...(SHOW_GAMES ? [{ href: '/games', label: 'Games' }] : []),
  ...(SHOW_SHOP ? [{ href: '/shop', label: 'Shop' }] : []),
];

export default function SiteNav({ solid, links = LINKS, brandHref = '#' }) {
  return (
    <header className={`site-nav${solid ? ' site-nav--solid' : ''}`}>
      <div className="site-nav__inner">
        <a href={brandHref} className="site-nav__brand" aria-label="Libby the Lion & Friends">
          <img
            src={headerLogo}
            alt=""
            className="site-nav__logo"
            width={36}
            height={36}
            decoding="async"
            aria-hidden
          />
          <span className="site-nav__brand-text">
            <span className="site-nav__brand-line">Libby the Lion</span>
            <span className="site-nav__brand-sub">&amp; Friends</span>
          </span>
        </a>
        <nav className="site-nav__links" aria-label="Primary">
          {links.map(({ href, label }) => (
            <a key={href} href={href} className="site-nav__link">
              {label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
